import { useRecoilCallback } from 'recoil'
import {
  editorTextBoxDraftsAtom,
  editorTextBoxPendingDeletesAtom,
} from '@/atoms/editorTextBoxAtoms'
import { editorAnchorPageId } from '@/utils/editor-text-box/editorTextBoxAdapter'

/**
 * Forget the unsaved text-box edits and pending deletes of pages the line no
 * longer has — a page the shuffler just deleted, or pages a layout change
 * elsewhere replaced. They can never be saved, and leaving them would send
 * them at the next Save, on whatever page set took their place.
 */
export const useDropEditorTextBoxWork = () =>
  useRecoilCallback(
    ({ set }) =>
      (pageIds: readonly string[]) => {
        if (pageIds.length === 0) return
        const gone = new Set(pageIds)
        set(editorTextBoxDraftsAtom, (prev) =>
          Object.fromEntries(
            Object.entries(prev).filter(
              ([, draft]) => !gone.has(editorAnchorPageId(draft.anchor)),
            ),
          ),
        )
        set(editorTextBoxPendingDeletesAtom, (prev) =>
          Object.fromEntries(
            Object.entries(prev).filter(([, pageId]) => !gone.has(pageId)),
          ),
        )
      },
    [],
  )

export default useDropEditorTextBoxWork
